module.exports = __webpack_public_path__ + "img/gallery02.620443bc.jpg";